export enum AnalyticsEvents {
    BUY_MORE_KEYS =  'buy_more_keys',
    TON_WALLET_CONNECTED = 'tonWalletConnected',
}